import { action } from "typesafe-actions";
import { ThunkAction } from "redux-thunk";
import { IStoreState } from "../../initialStoreState";
import { AnyAction } from "redux";
import { api } from "../../../api/api";
import {
  saveLoaderCompleted,
  saveLoaderProgress,
  showMessage,
} from "../../messages/messagesActions";
import {
  IhabitationalClaims,
} from "./habitationalClaim.types";
import { ERROR_MESSAGES } from "../../../constants/enums";
import { makeApiCall } from "../../../helpers/postRequest";
import { uploadMultipleFile } from "../../../features/FileUpload/utils";
import { IFileUpload } from "../../../features/FileUpload/components/FileUpload.type";
import { getUniqueId } from "../../../helpers";

export const FETCH_HABITATIONAL_CLAIM_LIST_PROGRESS =
  "FETCH_HABITATIONAL_CLAIM_LIST_PROGRESS";
export const FETCH_HABITATIONAL_CLAIM_LIST_SUCCESS =
  "FETCH_HABITATIONAL_CLAIM_LIST_SUCCESS";
export const FETCH_AUTOMOBILE_DRIVER_LIST_INFORMATION_FAILED =
  "FETCH_HABITATIONAL_CLAIM_LIST_FAILED";
export const CLEAR_HABITATIONAL_CLAIM_STATE = "CLEAR_HABITATIONAL_CLAIM_STATE";

export const clearHabitationalClaimState = () =>
  action(CLEAR_HABITATIONAL_CLAIM_STATE);

export const addHabitationalClaimAsync =
  (
    data: IhabitationalClaims,
    initialData: IhabitationalClaims,
    isUpdate: boolean,
    onCallback: (isSuccess: boolean, claim?: IhabitationalClaims) => void,
    isDuplicate?: boolean
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(saveLoaderProgress());
      let res;

      const asPayload = {
        customer_id: data.customer_id,
        policy_type: "HABITATIONAL",
        customer_policy_id: data.customer_policy_id,
        page_name: "Habitational Claims",
      };

      const { paths } = await uploadMultipleFile(
        data.file_upload_two || [],
        "POLICY",
        asPayload
      );
      if (isDuplicate) {
        res = await makeApiCall(
          {
            url: "/policy/update-habitational-claims",
            method: "POST",
            automation: {
              isUpdate: isUpdate,
              primaryFieldName: "customer_policy_id",
            },
          },
          initialData,
          {
            ...data,
            claim_number: null,
            line_of_business: "Habitational Policy",
            file_upload_two: paths,
          }
        );
      } else {
        res = await makeApiCall(
          {
            url: "/policy/create-habitational-claims",
            method: "POST",
            automation: {
              isUpdate: isUpdate,
              primaryFieldName: "customer_policy_id",
            },
          },
          initialData,
          {
            ...data,
            line_of_business: "Habitational Policy",
            file_upload_two: paths,
          }
        );
      }
      const finalResponse = res.data.data;
      onCallback(true, finalResponse);
      dispatch(
        showMessage({
          type: "success",
          message: "Claim saved successfully!",
          displayAs: "snackbar",
        })
      );
    } catch (err: any) {
      onCallback(false, undefined);
      dispatch(
        showMessage({
          type: "error",
          message: err.response?.data?.message || "Something went wrong",
          displayAs: "snackbar",
        })
      );
    } finally {
      dispatch(saveLoaderCompleted());
    }
  };

export const fetchHabitationalClaimListProgress = () =>
  action(FETCH_HABITATIONAL_CLAIM_LIST_PROGRESS);

export const fetchHabitationalClaimListSuccess = (
  data: IhabitationalClaims[]
) =>
  action(FETCH_HABITATIONAL_CLAIM_LIST_SUCCESS, {
    data,
  });

export const fetchHanitationalClaimListAsync =
  (
    customerPolicyId: number,
    status?: string
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(fetchHabitationalClaimListProgress());

      let finalUrl = `/policy/get-habitational-claims?customer_policy_id=${customerPolicyId}`;

      if (status !== undefined && status !== "-1") {
        finalUrl += "&status=" + status;
      }

      const res = await api.get(finalUrl);
      const data: IhabitationalClaims[] = res.data.data;
      dispatch(fetchHabitationalClaimListSuccess(data));
    } catch (err: any) {
      dispatch(
        showMessage({
          type: "error",
          message: err.response?.data?.message || "Something went wrong",
          displayAs: "snackbar",
        })
      );
    }
  };

export const FETCH_HABITATIONAL_CLAIM_PROGRESS =
  "FETCH_HABITATIONAL_CLAIM_PROGRESS";
export const FETCH_HABITATIONAL_CLAIM_SUCCESS =
  "FETCH_HABITATIONAL_CLAIM_SUCCESS";
export const FETCH_HABITATIONAL_CLAIM_FAILED =
  "FETCH_HABITATIONAL_CLAIM_FAILED";

export const fetchHabitationalClaimProgress = () =>
  action(FETCH_HABITATIONAL_CLAIM_PROGRESS);
export const fetchHabitationalClaimSuccess = (data: IhabitationalClaims) =>
  action(FETCH_HABITATIONAL_CLAIM_SUCCESS, {
    data,
  });
export const fetchHabitationalClaimFailed = (errorMessage: string) =>
  action(FETCH_HABITATIONAL_CLAIM_FAILED, { errorMessage });

export const fetchHabitationalClaimAsync =
  (
    customerPolicyId: number,
    incremental_number: number
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(fetchHabitationalClaimProgress());
      const res = await api.get(
        `/policy/get-habitational-claims?customer_policy_id=${customerPolicyId}&column=incremental_number&value=${incremental_number}`
      );
      const data: IhabitationalClaims[] = res.data.data;
      if (data.length > 0) {
         const attachments: IFileUpload[] = [];
                        for (const item of (data[0].file_upload_two || []) as any) {
                          if (item) {
                            attachments.push({
                              file: null,
                              key: getUniqueId(),
                              path: item,
                            });
                          }
                        }
        dispatch(
          fetchHabitationalClaimSuccess({
            ...data[0],
            file_upload_two: attachments,
          })
        );
      } else {
        dispatch(fetchHabitationalClaimFailed(ERROR_MESSAGES.POLICY_NOT_FOUND));
      }
    } catch (err: any) {
      dispatch(fetchHabitationalClaimFailed(ERROR_MESSAGES.SERVER_ERROR));
      dispatch(
        showMessage({
          type: "error",
          message: err.response?.data?.message || "Something went wrong",
          displayAs: "snackbar",
        })
      );
    }
  };
